import DashboardItem, { proseClasses } from './dashboard-item';
import { LinkTo } from '@ember/routing';
import { PhLink, PhLinkBreak } from 'ember-phosphor-icons';
import { Section, VStack } from 'tio-reimagined/components/layout';
import { service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import { htmlSafe } from '@ember/template';
import { dashboardIconSizes, contentWidths } from 'tio-employee/utils/wellness-insights';

const documentUploadLinkQuery = {
  providers: 'nslds,statement',
};

const feedbackQuery = {
  decline_account: true,
};

export default class WellnessInsightsDashAccountCreationPrompt extends DashboardItem {
  @service declare router: RouterService;

  get currentRoute(): string {
    return this.router.currentRouteName!;
  }

  get iconClass() {
    const definition = this.args.componentDefinition;
    switch (definition.type) {
      case 'add_account':
        return PhLink;
      case 'doesnt_have_loans':
      case 'not_adding_loans':
        return PhLinkBreak;
      default:
        throw new Error(
          `WellnessInsightsComponentDefinition id ${definition.id} type invalid for WellnessInsightsDashAccountCreationPrompt component`
        );
    }
  }

  <template>
    <VStack class="gap-4">
      <div class={{proseClasses}}>
        <h2 class="mt-0">{{this.translate "account_creation_prompt.title"}}</h2>
        {{this.translate "account_creation_prompt.body"}}
      </div>
      <Section class="gap-4">
        <:body>
          {{#let this.iconClass as |IconComponent|}}
            <IconComponent @size={{dashboardIconSizes.md}} class="block m-auto" />
          {{/let}}
          <div class="{{contentWidths.md}} {{proseClasses}}">{{htmlSafe
              @componentDefinition.text
            }}</div>
          <br />
          <LinkTo
            @route="authenticated.observability.upload"
            @query={{documentUploadLinkQuery}}
            class="tio-btn tio-btn--primary tio-btn--md block w-fit m-auto"
          >
            {{this.translate "account_creation_prompt.cta_text"}}
          </LinkTo>
          <br />
          <LinkTo
            @route={{this.currentRoute}}
            @query={{feedbackQuery}}
            class="tio-anchor block w-fit m-auto"
          >
            {{this.translate "account_creation_prompt.cta_alt"}}
          </LinkTo>
        </:body>
      </Section>
    </VStack>
  </template>
}
